import { render, staticRenderFns } from "./checkboxuniform.vue?vue&type=template&id=f578a0a0&"
import script from "./checkboxuniform.vue?vue&type=script&lang=js&"
export * from "./checkboxuniform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports